// cities

import List from '../../pages/Users/Customer/List';
import Detail from '../../pages/Users/Customer/Detail';

export const subRoutesUsersCustomer = [
    {
        path: "",
        component: List,
        exact: true,
    },
].map((item) => {
    return {
        ...item,
        path: `/customer${item.path}`,
        private: true
    };
});

export const routesUsersCustomer = [
    {
        path: "/:elementId",
        component: Detail,
    },
].map((item) => {
    return {
        ...item,
        path: `/customer${item.path}`,
        private: true
    };
});